import React, { forwardRef, useEffect, useState } from "react";
import { formatDate } from "../../../common/Validations";

const DEFAULT_COMPANY_INFO = {
  name: "Vensap LLP.",
  addressLine:
    "# 30, 2nd Cross , G1 - Ground Floor ,Hill View Garden Residency Layout, Turahalli ,Uttarahalli Hobli , Subramanyapura Post, Bangalore, Karnataka, 560061",
  phone: "+91-99025-79757",
  fax: "",
  website: "www.vensap.com",
  logo: "assets/img/logo.png",
  hrSignatoryName: "",
  hrSignatoryDesignation: "HR Department",
};

const JOINING_FORMALITY_DOCS = [
  "Certificates supporting your educational qualification along with marksheet*",
  "Schooling certificates (SSLC/ICSE) in support of your age",
  "12th class / Intermediate certificate",
  "Your latest salary slip or salary certificate in original*",
  "Your relieving letter from your previous/present organization in original",
  "Experience / Service certificate",
  "PAN Card and proof of PAN Number",
  "Permanent address proof, viz. Driving license / ration card / voter ID card",
  "Current address proof, viz. telephone bill / rent agreement",
  "Latest passport copy",
  "Non-Disclosure & Confidentiality Agreement to be signed at the time of joining",
];

const alphaLabel = (idx) =>
  String.fromCharCode(97 + idx) + ".";

const PrintDocuments = forwardRef((props, ref) => {
  const [data, setData] = useState({});

  useEffect(() => {
    setData(props?.data || {});
  }, [props]);

  const companyInfo = {
    ...DEFAULT_COMPANY_INFO,
    ...(props?.companyInfo || {}),
  };

  /*
   * ---------------------------------------------------------
   * STYLES
   * ---------------------------------------------------------
   */

  const styles = {
    container: {
      fontFamily: "'Times New Roman', Times, serif",
      fontSize: "11pt",
      lineHeight: 1.5,
      color: "#000",
      margin: "20px",
    },

    h2: {
      textAlign: "center",
      textTransform: "uppercase",
      fontSize: "14pt",
      fontWeight: "bold",
      letterSpacing: "1px",
      margin: "10px 0 16px 0",
    },

    sectionTitle: {
      fontWeight: "bold",
      fontSize: "11.5pt",
      textDecoration: "underline",
      margin: "14px 0 6px 0",
    },

    plainTable: {
      width: "100%",
      borderCollapse: "collapse",
      margin: "6px 0",
    },

    plainCell: {
      border: "none",
      padding: "2px 0",
      verticalAlign: "top",
      fontSize: "11pt",
    },

    para: {
      margin: "0 0 10px 0",
      textAlign: "justify",
    },

    listRow: {
      display: "flex",
      margin: "3px 0",
      paddingLeft: "4px",
    },

    listLabel: {
      width: "22px",
      flexShrink: 0,
    },

    footer: {
      fontSize: "9.5pt",
      textAlign: "center",
      marginTop: "24px",
      paddingTop: "6px",
      borderTop: "1px solid #999",
    },

    /*
     * SALARY TABLE STYLES
     */

    // salaryTable: {
    //   width: "100%",
    //   borderCollapse: "collapse",
    //   margin: "8px 0 16px 0",
    //   fontSize: "9.5pt",
    //   border: "1px solid #000",
    // },

    // salaryHeaderCell: {
    //   border: "1px solid #000",
    //   padding: "5px",
    //   fontWeight: "bold",
    //   verticalAlign: "middle",
    // },

    // salaryCell: {
    //   border: "1px solid #000",
    //   padding: "5px",
    //   verticalAlign: "top",
    // },

    // salaryAmountCell: {
    //   border: "1px solid #000",
    //   padding: "5px",
    //   textAlign: "right",
    //   verticalAlign: "top",
    //   whiteSpace: "nowrap",
    // },

    // salarySectionCell: {
    //   border: "1px solid #000",
    //   padding: "5px",
    //   fontWeight: "bold",
    //   backgroundColor: "#d9d9d9",
    //   verticalAlign: "middle",
    // },

    // salarySubtotalCell: {
    //   border: "1px solid #000",
    //   padding: "5px",
    //   fontWeight: "bold",
    //   backgroundColor: "#d9d9d9",
    //   verticalAlign: "top",
    // },

    // salaryTotalCell: {
    //   border: "1px solid #000",
    //   padding: "5px",
    //   fontWeight: "bold",
    //   backgroundColor: "#808080",
    //   color: "#fff",
    //   verticalAlign: "top",
    // },

    salaryTable: {
  width: "100%",
  borderCollapse: "collapse",
  tableLayout: "fixed",
  margin: "8px 0 14px 0",
  fontSize: "8.5pt",
  border: "1px solid #000",
},

salaryHeaderCell: {
  border: "1px solid #000",
  padding: "4px 5px",
  fontWeight: "bold",
  verticalAlign: "middle",
},

salaryCell: {
  border: "1px solid #000",
  padding: "4px 5px",
  verticalAlign: "middle",
  textAlign: "left",
  lineHeight: 1.25,
  wordBreak: "normal",
  overflowWrap: "break-word",
},

salaryAmountCell: {
  border: "1px solid #000",
  padding: "4px 5px",
  verticalAlign: "middle",
  textAlign: "right",
  whiteSpace: "nowrap",
  lineHeight: 1.25,
},

salarySectionCell: {
  border: "1px solid #000",
  padding: "4px 5px",
  fontWeight: "bold",
  backgroundColor: "#d9d9d9",
  verticalAlign: "middle",
  textAlign: "left",
},

salarySubtotalCell: {
  border: "1px solid #000",
  padding: "4px 5px",
  fontWeight: "bold",
  backgroundColor: "#d9d9d9",
  verticalAlign: "middle",
  textAlign: "left",
},

salarySubtotalAmountCell: {
  border: "1px solid #000",
  padding: "4px 5px",
  fontWeight: "bold",
  backgroundColor: "#d9d9d9",
  verticalAlign: "middle",
  textAlign: "right",
  whiteSpace: "nowrap",
},

salaryTotalCell: {
  border: "1px solid #000",
  padding: "4px 5px",
  fontWeight: "bold",
  backgroundColor: "#808080",
  color: "#fff",
  verticalAlign: "middle",
  textAlign: "left",
},
  };

  const printbody = {
    display: "flex",
    flexDirection: "column",
    margin: "10px",
  };
  const reportingDetail =
    (data?.reportingDetails &&
      data.reportingDetails[0]) ||
    {};

  const contactList =
    data?.contactDetails || [];

  const managerContact =
    contactList.find((c) =>
      (
        c.contactPositionDesc ||
        c.contactPosition ||
        ""
      )
        .toLowerCase()
        .includes("manager")
    ) ||
    contactList[0] ||
    {};

  const reportingManagerName =
    reportingDetail?.contactName ||
    managerContact?.contactName ||
    "________";

  const reportingManagerNumber =
    reportingDetail?.contactNumber ||
    managerContact?.contactNumber ||
    "";

  const reportingManagerEmail =
    reportingDetail?.contactEmail ||
    managerContact?.contactEmail ||
    "";

  const reportingFormalitiesPhone =
    reportingManagerNumber ||
    companyInfo.phone;
  const employeeAddress = [
    data?.address,
    data?.address2,
    data?.city,
    data?.state,
    data?.cityPostalCode,
    data?.country,
  ]
    .filter(Boolean)
    .join(", ");
  const companyAddressParts = [
    companyInfo.addressLine,
  ]
    .filter(Boolean)
    .join(", ");
  const offerDate = data?.createdAt
    ? formatDate(data.createdAt)
    : "";

  const joiningDate = data?.joiningDate
    ? formatDate(data.joiningDate)
    : data?.effectiveDate
      ? formatDate(data.effectiveDate)
      : "________";

  const offerValidTill =
    data?.offerValidTill
      ? formatDate(data.offerValidTill)
      : "";

  const grossSalary = data?.grossSalary
    ? `₹${data.grossSalary}/-`
    : data?.salaryAmt?.monthly?.grossSalaryAmt
      ? `₹${Number(
          data.salaryAmt.monthly.grossSalaryAmt
        ).toLocaleString("en-IN")}/-`
      : "as per Company policy";

  const positionTitle =
    data?.designationDesc ||
    data?.designation ||
    data?.jobRoleDesc ||
    data?.jobRole ||
    "________";

  const relievingDate =
    data?.relievingDate ||
    "________";

  const resignationDate =
    data?.resignationDate ||
    "________";

  const proPositionTitle =
    data?.proDesignation ||
    data?.proDesignationDesc ||
    "________";

  const supervisorName =
    data?.supervisorName ||
    reportingManagerName;

  const hrContactName =
    data?.hrContactName ||
    "the HR Team";

  const hrSignatoryName =
    companyInfo.hrSignatoryName ||
    data?.createdBy ||
    "Authorized Signatory";

  const hrSignatoryDesignation =
    companyInfo.hrSignatoryDesignation ||
    "HR Department";

  const salaryAmt =
    data?.salaryAmt || {};

  const monthlySalary =
    salaryAmt?.monthly || {};

  const annualSalary =
    salaryAmt?.annual || {};

  const salaryFmt = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "0";
    }

    const numberValue = Number(value);

    if (Number.isNaN(numberValue)) {
      return "0";
    }

    return numberValue.toLocaleString(
      "en-IN"
    );
  };

  // const renderSalaryTable = () => (
  //   <div
  //     style={{
  //       marginTop: "14px",
  //       marginBottom: "16px",
  //     }}
  //   >
  //     <div
  //       style={{
  //         fontWeight: "bold",
  //         fontSize: "11.5pt",
  //         marginBottom: "6px",
  //       }}
  //     >
  //       Salary Break-up
  //     </div>

  //     <table style={styles.salaryTable}>
  //       <thead>
  //         <tr>
  //           <th
  //             style={{
  //               ...styles.salaryHeaderCell,
  //               width: "32%",
  //               textAlign: "left",
  //             }}
  //           >
  //             Salary Components
  //           </th>

  //           <th
  //             style={{
  //               ...styles.salaryHeaderCell,
  //               width: "15%",
  //               textAlign: "right",
  //             }}
  //           >
  //             Monthly
  //           </th>

  //           <th
  //             style={{
  //               ...styles.salaryHeaderCell,
  //               width: "15%",
  //               textAlign: "right",
  //             }}
  //           >
  //             Annual
  //           </th>

  //           <th
  //             style={{
  //               ...styles.salaryHeaderCell,
  //               width: "38%",
  //               textAlign: "left",
  //             }}
  //           >
  //             Remarks
  //           </th>
  //         </tr>
  //       </thead>

  //       <tbody>
  //         {/* BASIC SALARY */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Basic Salary
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.basicSalaryAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.basicSalaryAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             40% of the Gross
  //           </td>
  //         </tr>

  //         {/* HRA */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             HRA
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.hraAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.hraAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             40% of Basic
  //           </td>
  //         </tr>

  //         {/* SPECIAL ALLOWANCE */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Special Allowance
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.specialAllowanceAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.specialAllowanceAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             Balance Amount
  //           </td>
  //         </tr>

  //         {/* FLEXIBLE BENEFIT PLAN */}

  //         <tr>
  //           <td
  //             colSpan={4}
  //             style={styles.salarySectionCell}
  //           >
  //             Flexible Benefit Plan
  //           </td>
  //         </tr>

  //         {/* LTA */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             LTA
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.ltaAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.ltaAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             Eligible for two months of basic
  //             per year as per LTA applicability
  //           </td>
  //         </tr>

  //         {/* MEDICAL */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Medical Allowance
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.medicalAllowanceAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.medicalAllowanceAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             As per the Income Tax Act
  //           </td>
  //         </tr>

  //         {/* CONVEYANCE */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Conveyance Allowance
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.conveyanceAllowanceAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.conveyanceAllowanceAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             As per the Income Tax Act
  //           </td>
  //         </tr>

  //         {/* FOOD VOUCHERS */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Food Vouchers
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.foodVouchersAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.foodVouchersAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             As per IT &amp; FBT
  //           </td>
  //         </tr>

  //         {/* GROSS SALARY */}

  //         <tr>
  //           <td style={styles.salarySubtotalCell}>
  //             Gross Salary
  //           </td>

  //           <td style={styles.salarySubtotalCell}>
  //             {salaryFmt(
  //               monthlySalary.grossSalaryAmt
  //             )}
  //           </td>

  //           <td style={styles.salarySubtotalCell}>
  //             {salaryFmt(
  //               annualSalary.grossSalaryAmt
  //             )}
  //           </td>

  //           <td style={styles.salarySubtotalCell}>
  //             &nbsp;
  //           </td>
  //         </tr>

  //         {/* PROVIDENT FUND */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Provident Fund
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.providentFundAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.providentFundAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             Company Contribution
  //           </td>
  //         </tr>

  //         {/* GRATUITY */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Gratuity
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.gratuityAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.gratuityAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             Company Contribution
  //           </td>
  //         </tr>

  //         {/* ON-POST ALLOWANCE */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             On-Post Allowance
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.onPostAllowanceAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.onPostAllowanceAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             In Lieu of Per diem and paid on
  //             Active Billing and varies based
  //             on base location. Not applicable
  //             for Onsite Overseas Projects
  //           </td>
  //         </tr>

  //         {/* MONTHLY PERFORMANCE PAY */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Monthly Performance Pay
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.monthlyPerformancePayAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.monthlyPerformancePayAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             Payable Monthly based on
  //             Performance and Incentive Policy
  //           </td>
  //         </tr>

  //         {/* QUARTERLY PERFORMANCE PAY */}

  //         <tr>
  //           <td style={styles.salaryCell}>
  //             Quarterly Performance Pay
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               monthlySalary.quarterlyPerformancePayAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryAmountCell}>
  //             {salaryFmt(
  //               annualSalary.quarterlyPerformancePayAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryCell}>
  //             Payable based on achievement of
  //             company collection target. Paid
  //             in the months of July, Oct, Jan
  //             and Apr
  //           </td>
  //         </tr>

  //         {/* CTC */}

  //         <tr>
  //           <td style={styles.salaryTotalCell}>
  //             CTC
  //           </td>

  //           <td style={styles.salaryTotalCell}>
  //             {salaryFmt(
  //               monthlySalary.ctcAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryTotalCell}>
  //             {salaryFmt(
  //               annualSalary.ctcAmt
  //             )}
  //           </td>

  //           <td style={styles.salaryTotalCell}>
  //             &nbsp;
  //           </td>
  //         </tr>
  //       </tbody>
  //     </table>
  //   </div>
  // );
const renderSalaryTable = () => (
  <div
    style={{
      marginTop: "10px",
      marginBottom: "14px",
      width: "100%",
    }}
  >
    <div
      style={{
        fontWeight: "bold",
        fontSize: "10.5pt",
        marginBottom: "5px",
      }}
    >
      Salary Break-up
    </div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        tableLayout: "fixed",
        fontSize: "8.5pt",
        border: "1px solid #000",
        margin: 0,
      }}
    >
      {/* FIXED COLUMN WIDTHS */}
      <colgroup>
        <col style={{ width: "24%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "13%" }} />
        <col style={{ width: "51%" }} />
      </colgroup>

      <thead>
        <tr>
          <th
            style={{
              ...styles.salaryHeaderCell,
              textAlign: "left",
              padding: "4px 5px",
              verticalAlign: "middle",
              whiteSpace: "nowrap",
            }}
          >
            Salary Components
          </th>

          <th
            style={{
              ...styles.salaryHeaderCell,
              textAlign: "right",
              padding: "4px 5px",
              verticalAlign: "middle",
              whiteSpace: "nowrap",
            }}
          >
            Monthly
          </th>

          <th
            style={{
              ...styles.salaryHeaderCell,
              textAlign: "right",
              padding: "4px 5px",
              verticalAlign: "middle",
              whiteSpace: "nowrap",
            }}
          >
            Annual
          </th>

          <th
            style={{
              ...styles.salaryHeaderCell,
              textAlign: "left",
              padding: "4px 5px",
              verticalAlign: "middle",
            }}
          >
            Remarks
          </th>
        </tr>
      </thead>

      <tbody>

        {/* BASIC SALARY */}

        <tr>
          <td style={styles.salaryCell}>
            Basic Salary
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.basicSalaryAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.basicSalaryAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            40% of the Gross
          </td>
        </tr>

        {/* HRA */}

        <tr>
          <td style={styles.salaryCell}>
            HRA
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.hraAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.hraAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            40% of Basic
          </td>
        </tr>

        {/* SPECIAL ALLOWANCE */}

        <tr>
          <td style={styles.salaryCell}>
            Special Allowance
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.specialAllowanceAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.specialAllowanceAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            Balance Amount
          </td>
        </tr>

        {/* FLEXIBLE BENEFIT PLAN */}

        <tr>
          <td
            colSpan={4}
            style={{
              ...styles.salarySectionCell,
              textAlign: "left",
              padding: "4px 5px",
            }}
          >
            Flexible Benefit Plan
          </td>
        </tr>

        {/* LTA */}

        <tr>
          <td style={styles.salaryCell}>
            LTA
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.ltaAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.ltaAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            Eligible for two months of basic
            per year as per LTA applicability
          </td>
        </tr>

        {/* MEDICAL */}

        <tr>
          <td style={styles.salaryCell}>
            Medical Allowance
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.medicalAllowanceAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.medicalAllowanceAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            As per the Income Tax Act
          </td>
        </tr>

        {/* CONVEYANCE */}

        <tr>
          <td style={styles.salaryCell}>
            Conveyance Allowance
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.conveyanceAllowanceAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.conveyanceAllowanceAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            As per the Income Tax Act
          </td>
        </tr>

        {/* FOOD */}

        <tr>
          <td style={styles.salaryCell}>
            Food Vouchers
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.foodVouchersAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.foodVouchersAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            As per IT &amp; FBT
          </td>
        </tr>

        {/* GROSS SALARY */}

        <tr>
          <td style={styles.salarySubtotalCell}>
            Gross Salary
          </td>

          <td style={styles.salarySubtotalAmountCell}>
            {salaryFmt(
              monthlySalary.grossSalaryAmt
            )}
          </td>

          <td style={styles.salarySubtotalAmountCell}>
            {salaryFmt(
              annualSalary.grossSalaryAmt
            )}
          </td>

          <td style={styles.salarySubtotalCell}>
            &nbsp;
          </td>
        </tr>

        {/* PF */}

        <tr>
          <td style={styles.salaryCell}>
            Provident Fund
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.providentFundAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.providentFundAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            Company Contribution
          </td>
        </tr>

        {/* GRATUITY */}

        <tr>
          <td style={styles.salaryCell}>
            Gratuity
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.gratuityAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.gratuityAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            Company Contribution
          </td>
        </tr>

        {/* ON POST */}

        <tr>
          <td style={styles.salaryCell}>
            On-Post Allowance
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.onPostAllowanceAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.onPostAllowanceAmt
            )}
          </td>

          <td
            style={{
              ...styles.salaryCell,
              fontSize: "8pt",
              lineHeight: 1.25,
            }}
          >
            In Lieu of Per diem and paid on
            Active Billing and varies based on
            base location. Not applicable for
            Onsite Overseas Projects
          </td>
        </tr>

        {/* MONTHLY PERFORMANCE */}

        <tr>
          <td style={styles.salaryCell}>
            Monthly Performance Pay
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.monthlyPerformancePayAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.monthlyPerformancePayAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            Payable Monthly based on Performance
            and Incentive Policy
          </td>
        </tr>

        {/* QUARTERLY PERFORMANCE */}

        <tr>
          <td style={styles.salaryCell}>
            Quarterly Performance Pay
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              monthlySalary.quarterlyPerformancePayAmt
            )}
          </td>

          <td style={styles.salaryAmountCell}>
            {salaryFmt(
              annualSalary.quarterlyPerformancePayAmt
            )}
          </td>

          <td style={styles.salaryCell}>
            Payable based on achievement of
            company collection target. Paid in
            the months of July, Oct, Jan and Apr
          </td>
        </tr>

        {/* CTC */}

        <tr>
          <td style={styles.salaryTotalCell}>
            CTC
          </td>

          <td
            style={{
              ...styles.salaryTotalCell,
              textAlign: "right",
              whiteSpace: "nowrap",
            }}
          >
            {salaryFmt(
              monthlySalary.ctcAmt
            )}
          </td>

          <td
            style={{
              ...styles.salaryTotalCell,
              textAlign: "right",
              whiteSpace: "nowrap",
            }}
          >
            {salaryFmt(
              annualSalary.ctcAmt
            )}
          </td>

          <td style={styles.salaryTotalCell}>
            &nbsp;
          </td>
        </tr>

      </tbody>
    </table>
  </div>
);

  const renderContent = () => {
    switch (data?.hrDocTypeCode) {
      case "OFF":
        return renderOfferLetter();

      case "PRO":
        return renderPromotionLetter();

      case "REG":
        return relivingLetter();

      default:
        return (
          <div style={styles.container}>
            <p>
              No print template configured for
              document type:{" "}
              {data?.hrDocType || "Unknown"}
            </p>
          </div>
        );
    }
  };

  const renderOfferLetter = () => (
    <div style={styles.container}>

      {/* LETTERHEAD */}

      <table style={styles.plainTable}>
        <tbody>
          <tr>
            <td
              style={{
                ...styles.plainCell,
                width: "70%",
              }}
            >
              {companyInfo.logo ? (
                <img
                  src={companyInfo.logo}
                  alt="logo"
                  style={{
                    height: "40px",
                  }}
                />
              ) : null}

              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "13pt",
                }}
              >
                {companyInfo.name}
              </div>
            </td>

            <td
              style={{
                ...styles.plainCell,
                textAlign: "right",
              }}
            >
              {offerDate}
              <br />
              {data?.city || ""}
            </td>
          </tr>
        </tbody>
      </table>

      {/* TITLE */}

      <h2 style={styles.h2}>
        Offer Letter
      </h2>

      {/* REFERENCE */}

      {data?.hrDocNr && (
        <p style={styles.para}>
          <strong>Ref No:</strong>{" "}
          {data.hrDocNr}
        </p>
      )}

      {/* EMPLOYEE */}

      <p
        style={{
          margin: "2px 0",
        }}
      >
        <strong>
          {data?.employeeName}
        </strong>
      </p>

      {employeeAddress && (
        <p
          style={{
            margin: "2px 0 14px 0",
          }}
        >
          {employeeAddress}
        </p>
      )}

      {/* GREETING */}

      <p style={styles.para}>
        Dear{" "}
        {data?.firstName ||
          data?.employeeName}
        ,
      </p>

      <p style={styles.para}>
        <strong>
          Congratulations!
        </strong>
      </p>

      {/* OFFER */}

      <p style={styles.para}>
        On behalf of{" "}
        <strong>
          {companyInfo.name}
        </strong>
        , we are pleased to offer you a
        position as{" "}
        <strong>
          "{positionTitle}"
        </strong>{" "}
        with {companyInfo.name}, effective
        from{" "}
        <strong>
          {joiningDate}
        </strong>
        .
      </p>

      {/* TERMS */}

      <p style={styles.para}>
        The terms and conditions of your
        employment and the terms of your
        continued employment with the Company
        are as contained in Exhibit A &amp;
        Exhibit B. This letter together with
        Exhibit A &amp; Exhibit B
        (collectively referred as
        "Agreement") when signed by you and an
        authorized company representative will
        be a legally binding Agreement.
      </p>

      {/* GROSS SALARY */}

      <p style={styles.para}>
        You shall be paid a monthly gross
        salary of{" "}
        <strong>
          {grossSalary}
        </strong>{" "}
        in accordance with the Company's
        standard pay roll practices for
        salaried people in India.
      </p>

      {/* SALARY TABLE */}

      {data?.salaryAmt &&
        Object.keys(data.salaryAmt).length >
          0 &&
        renderSalaryTable()}

      {/* LOCATION */}

      <p style={styles.para}>
        You shall be posted at{" "}
        {data?.city || "________"} and you
        will be under probation for a period
        of Three months from the date of
        joining.
      </p>

      {/* REPORTING MANAGER */}

      <p style={styles.para}>
        You shall report to{" "}
        <strong>
          {reportingManagerName}
        </strong>

        {reportingManagerNumber && (
          <>
            {" "}
            (Contact:{" "}
            {reportingManagerNumber}
            {reportingManagerEmail
              ? `, ${reportingManagerEmail}`
              : ""}
            )
          </>
        )}{" "}
        and discharge all duties and
        obligations under the supervision,
        instructions and control of{" "}
        <strong>
          {supervisorName}
        </strong>
        .
      </p>

      {/* REPORTING FORMALITIES */}

      <div style={styles.sectionTitle}>
        Reporting Formalities
      </div>

      <p style={styles.para}>
        You are requested to report to{" "}
        <strong>
          {hrContactName}
        </strong>{" "}
        at 9:30 AM to complete the joining
        formalities at{" "}
        {companyInfo.name}
        {companyAddressParts
          ? `, ${companyAddressParts}`
          : ""}
        {reportingFormalitiesPhone
          ? `, Phone # ${reportingFormalitiesPhone}`
          : ""}
        . At the time of reporting, you are
        requested to submit photocopies of
        the following:
      </p>

      {/* DOCUMENT LIST */}

      <div>
        {JOINING_FORMALITY_DOCS.map(
          (doc, idx) => (
            <div
              key={idx}
              style={styles.listRow}
            >
              <span
                style={styles.listLabel}
              >
                {alphaLabel(idx)}
              </span>

              <span>
                {doc}
              </span>
            </div>
          )
        )}
      </div>

      <p
        style={{
          ...styles.para,
          fontStyle: "italic",
          marginTop: "8px",
        }}
      >
        * also bring originals
      </p>

      {/* BACKGROUND VERIFICATION */}

      <p style={styles.para}>
        This offer is purely based on the
        information / documents provided by
        you and by accepting the offer, you
        specifically authorize the Company or
        any External agency through{" "}
        {companyInfo.name} to verify your
        educational, employment antecedents,
        your conduct and any other background
        checks prior to your joining the company
        or thereafter. You shall extend your
        co-operation (if asked for) during such
        verification without any protest or
        demur.
      </p>

      {/* ACCEPTANCE */}

      <p style={styles.para}>
        <strong>
          Please sign the duplicate of this
          letter as a token of your acceptance
          of the terms and conditions mentioned
          herein.
        </strong>
      </p>

      {/* CLOSING */}

      <p style={styles.para}>
        We are looking forward to a productive
        relationship between you and the
        Company.

        {offerValidTill && (
          <>
            {" "}
            This offer will expire, if not
            accepted by{" "}
            <strong>
              {offerValidTill}
            </strong>
            .
          </>
        )}
      </p>

      <p
        style={{
          margin: "0 0 4px 0",
        }}
      >
        Wishing you all the best.
      </p>

      {/* SIGNATURE */}

      <table style={styles.plainTable}>
        <tbody>
          <tr>
            <td
              style={{
                ...styles.plainCell,
                width: "50%",
              }}
            >
              For{" "}
              <strong>
                {companyInfo.name}
              </strong>

              <br />
              <br />
              <br />

              {hrSignatoryName}

              <br />

              {hrSignatoryDesignation}
            </td>

            <td
              style={{
                ...styles.plainCell,
                textAlign: "right",
                width: "50%",
              }}
            >
              Employee Signature

              <br />
              <br />
              <br />

              ______________________

              <br />

              ({data?.employeeName})
            </td>
          </tr>
        </tbody>
      </table>

      {/* FOOTER */}

      <p style={styles.footer}>
        {companyAddressParts}

        {companyInfo.phone
          ? ` | Tel: ${companyInfo.phone}`
          : ""}

        {companyInfo.fax
          ? ` | Fax: ${companyInfo.fax}`
          : ""}

        {companyInfo.website
          ? ` | ${companyInfo.website}`
          : ""}
      </p>
    </div>
  );

  const renderPromotionLetter = () => (
    <div style={styles.container}>

      {/* LETTERHEAD */}

      <table style={styles.plainTable}>
        <tbody>
          <tr>
            <td
              style={{
                ...styles.plainCell,
                width: "70%",
              }}
            >
              {companyInfo.logo ? (
                <img
                  src={companyInfo.logo}
                  alt="logo"
                  style={{
                    height: "40px",
                  }}
                />
              ) : null}

              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "13pt",
                }}
              >
                {companyInfo.name}
              </div>
            </td>

            <td
              style={{
                ...styles.plainCell,
                textAlign: "right",
              }}
            >
              {offerDate}
              <br />
              {data?.city || ""}
            </td>
          </tr>
        </tbody>
      </table>

      <h2 style={styles.h2}>
        Promotion Letter
      </h2>

      {data?.hrDocNr && (
        <p style={styles.para}>
          <strong>Ref No:</strong>{" "}
          {data.hrDocNr}
        </p>
      )}

      <p
        style={{
          margin: "2px 0",
        }}
      >
        <strong>
          {data?.employeeName}
        </strong>
      </p>

      <p
        style={{
          margin: "2px 0",
        }}
      >
        <strong>
          {data?.userId}
        </strong>
      </p>

      {employeeAddress && (
        <p
          style={{
            margin: "2px 0 14px 0",
          }}
        >
          {employeeAddress}
        </p>
      )}

      <p style={styles.para}>
        Dear{" "}
        {data?.firstName ||
          data?.employeeName}
        ,
      </p>

      <p style={styles.para}>
        <strong>
          Congratulations!
        </strong>
      </p>

      <p style={styles.para}>
        On behalf of{" "}
        <strong>
          {companyInfo.name}
        </strong>
        , In recognition of your
        <strong>
          {" "}
          Dedication and Contribution{" "}
        </strong>
        the Management of{" "}
        {companyInfo.name}, by way of
        apprecation, would like to congratulate
        and promote you as{" "}
        <strong>
          {proPositionTitle}
        </strong>{" "}
        with effect from{" "}
        <strong>
          {joiningDate}
        </strong>
        .
      </p>

      <p style={styles.para}>
        You shall report to{" "}
        <strong>
          {reportingManagerName}
        </strong>

        {reportingManagerNumber && (
          <>
            {" "}
            (Contact:{" "}
            {reportingManagerNumber}
            {reportingManagerEmail
              ? `, ${reportingManagerEmail}`
              : ""}
            )
          </>
        )}{" "}
        and would be a part of{" "}
        {companyInfo.name} Team, Your base
        location would be Bengaluru
      </p>

      <p style={styles.para}>
        We look forward to your continued job
        excellence and contribution in future
        Wishing you all the best,
      </p>

      <p style={styles.para}>
        <strong>
          Please sign the duplicate of this
          letter as a token of your acceptance
          of the terms and conditions mentioned
          herein.
        </strong>
      </p>

      <p style={styles.para}>
        We are looking forward to a productive
        relationship between you and the
        Company.

        {offerValidTill && (
          <>
            {" "}
            This offer will expire, if not
            accepted by{" "}
            <strong>
              {offerValidTill}
            </strong>
            .
          </>
        )}
      </p>

      <p
        style={{
          margin: "0 0 4px 0",
        }}
      >
        Wishing you all the best.
      </p>

      <table style={styles.plainTable}>
        <tbody>
          <tr>
            <td
              style={{
                ...styles.plainCell,
                width: "50%",
              }}
            >
              For{" "}
              <strong>
                {companyInfo.name}
              </strong>

              <br />
              <br />
              <br />

              {hrSignatoryName}

              <br />

              {hrSignatoryDesignation}
            </td>

            <td
              style={{
                ...styles.plainCell,
                textAlign: "right",
                width: "50%",
              }}
            >
              Employee Signature

              <br />
              <br />
              <br />

              ______________________

              <br />

              ({data?.employeeName})
            </td>
          </tr>
        </tbody>
      </table>

      <p style={styles.footer}>
        {companyAddressParts}

        {companyInfo.phone
          ? ` | Tel: ${companyInfo.phone}`
          : ""}

        {companyInfo.fax
          ? ` | Fax: ${companyInfo.fax}`
          : ""}

        {companyInfo.website
          ? ` | ${companyInfo.website}`
          : ""}
      </p>
    </div>
  );

  const relivingLetter = () => (
    <div style={styles.container}>

      {/* LETTERHEAD */}

      <table style={styles.plainTable}>
        <tbody>
          <tr>
            <td
              style={{
                ...styles.plainCell,
                width: "70%",
              }}
            >
              {companyInfo.logo ? (
                <img
                  src={companyInfo.logo}
                  alt="logo"
                  style={{
                    height: "40px",
                  }}
                />
              ) : null}

              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "13pt",
                }}
              >
                {companyInfo.name}
              </div>
            </td>

            <td
              style={{
                ...styles.plainCell,
                textAlign: "right",
              }}
            >
              {offerDate}
              <br />
              {data?.city || ""}
            </td>
          </tr>
        </tbody>
      </table>

      <h2 style={styles.h2}>
        RELIEVING / EXPERIENCE LETTER
      </h2>

      {data?.hrDocNr && (
        <p style={styles.para}>
          <strong>Ref No:</strong>{" "}
          {data.hrDocNr}
        </p>
      )}

      <p style={styles.para}>
        This is to certify that{" "}
        <strong>
          {data?.salutation ||
            (data?.gender === "female"
              ? "Ms."
              : "Mr.")}{" "}
          {data?.employeeName}
        </strong>{" "}
        {data?.userId
          ? `(Emp. No. ${data.userId})`
          : ""}{" "}
        has worked with us as{" "}
        <strong>
          {positionTitle}
        </strong>{" "}
        from{" "}
        <strong>
          {joiningDate}
        </strong>{" "}
        to{" "}
        <strong>
          {relievingDate}
        </strong>
        . Subsequent to{" "}
        {data?.gender === "female"
          ? "her"
          : "his"}{" "}
        resignation dated{" "}
        <strong>
          {resignationDate}
        </strong>
        ,{" "}
        {data?.gender === "female"
          ? "she"
          : "he"}{" "}
        has been relieved from{" "}
        {data?.gender === "female"
          ? "her"
          : "his"}{" "}
        duties with effect from{" "}
        <strong>
          {relievingDate}
        </strong>
        .
      </p>

      <p style={styles.para}>
        During{" "}
        {data?.gender === "female"
          ? "her"
          : "his"}{" "}
        tenure,{" "}
        {data?.gender === "female"
          ? "she"
          : "he"}{" "}
        has undertaken various tasks and
        successfully completed them to the best
        of{" "}
        {data?.gender === "female"
          ? "her"
          : "his"}{" "}
        abilities. Conduct during this period
        was found to be good.
      </p>

      <p style={styles.para}>
        We truly appreciate{" "}
        {data?.gender === "female"
          ? "her"
          : "his"}{" "}
        dedication and contribution towards
        company's growth.
      </p>

      <p style={styles.para}>
        We wish{" "}
        {data?.gender === "female"
          ? "her"
          : "him"}{" "}
        every success for{" "}
        {data?.gender === "female"
          ? "her"
          : "his"}{" "}
        future endeavors.
      </p>

      <p
        style={{
          margin: "20px 0 4px 0",
        }}
      >
        With best wishes,
      </p>

      <table
        style={{
          ...styles.plainTable,
          marginTop: "30px",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                ...styles.plainCell,
                width: "50%",
              }}
            >
              For{" "}
              <strong>
                {companyInfo.name}
              </strong>

              <br />
              <br />
              <br />

              {hrSignatoryName}

              <br />

              {hrSignatoryDesignation}
            </td>
          </tr>
        </tbody>
      </table>

      <p style={styles.footer}>
        {companyAddressParts}

        {companyInfo.phone
          ? ` | Tel: ${companyInfo.phone}`
          : ""}

        {companyInfo.fax
          ? ` | Fax: ${companyInfo.fax}`
          : ""}

        {companyInfo.website
          ? ` | ${companyInfo.website}`
          : ""}
      </p>
    </div>
  );
  return (
    <div
      ref={ref}
      style={printbody}
      className="m-4"
    >
      {renderContent()}
    </div>
  );
});

export default PrintDocuments;